import React from "react";
import {
    Heading,
    ListItem,
    List,
    Text
} from "spectacle";
import Button from '../components/Button';

const OurSolutionBenefits = () =>
    <div>
        <Heading size={6} textColor="secondary" caps bold>
            Our Solution - AI POWERED SLIDES
        </Heading>
        <Text textSize={30} textColor="primary">
            Benefits for the sales organization
        </Text>
        <List ordered textColor="secondary" style={{ paddingLeft: '25px', listStylePosition: 'outside' }}>
            <ListItem textSize={25}>Recommends the right next action per prospect</ListItem>
            <ListItem textSize={25}>Personalized conversations during crucial early-stage engagement</ListItem>
            <ListItem textSize={25}>Gives additional intelligence for lead scoring (probability to become a customer)</ListItem>
            <ListItem textSize={25}>More accurate forecasting and performance metrics based on real-time telemetry</ListItem>
            <ListItem textSize={25}>SaaS based means better performance</ListItem>
            <ListItem textSize={25}>Mobile optimized</ListItem>
        </List>
    </div>

export default OurSolutionBenefits;


// WEBPACK FOOTER //
// ./src/slides/OurSolutionBenefits.js